module.exports = __webpack_public_path__ + "static/MT_Benefit-05.e09aa011.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-05.png
// module id = 1465
// module chunks = 169858455373905